<template>
    <div>
        <v-dialog @keydown.esc="dialog = false" v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span>
                        <strong>Upload de arquivo - {{ component.text }}</strong>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialog = false">
                        <v-icon color="red">close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        
                        <span class="inputFile">
                            <label for="file-upload" class="custom-file-upload" @click="resetInfos()">
                                <v-icon>mdi-file</v-icon>
                                {{  path ? path : 'Selecione um arquivo'}}
                            </label>
                            <small>
                                {{fileText}}
                                <span class="teal_bold">{{path}}</span>
                            </small>
                            <input
                                type="file"
                                @change="setFile($event)"
                                name="file-upload"
                                value="file"
                                @keypress.enter.prevent
                                @keydown.enter.prevent
                                id="file-upload"
                                
                            />
                            <br />
                        </span>

                    </v-container>
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.stop="dialog=false">Fechar</v-btn>
                <v-btn color="success" @click.stop="handleUpload">Upload</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn class="uploadBtn" @click="resetInfos">
            Upload Arquivo
        </v-btn>
    </div>
</template>

<script>
export default {
    props: ["component"],
    data() {
        return {
            dialog: false,
            fileText: "Nenhum arquivo selecionado",
            path: "",
            file: {},
        }
    },
    computed: {
        files() {
            return this.$store.getters.files;
        }
    },
    methods: {
        resetInfos() {
            let file = document.querySelector("#file-upload");
            file.value = "";

            this.path = "";
            this.fileText = "Nenhum arquivo selecionado";
            this.dialog = true;
        },
        setFile: function(e) {
            console.log(e.target);
            this.path = "";
            if (e.target.type == "file") {
                if (e.target.files.length > 0) {
                    console.log(e);
                    this.fileText = "Arquivo selecionado: ";
                    this.path = e.target.files[0].name;
                    console.log((e.target.files[0].size / 1000).toFixed(1));
                    console.log(this.convertDate());
                    console.log(this.convertDate(e.target.files[0].lastModifiedDate));
                    this.file = {
                        idDocumento: "111111111111111111",
                        nome: e.target.files[0].name,
                        origem: "robo",
                        // tamanho: (e.target.files[0].size / 1000).toFixed(1),
                        // dataIni: this.convertDate(),
                        // dataMod: this.convertDate(e.target.files[0].lastModifiedDate),
                    }

                } else {
                    this.fileText = "Nenhum arquivo selecionado";
                }
            }else {
                return;
            }
        },
        handleUpload() {
            // console.log(this.file);
            this.$store.commit('addFiles', this.file);
            // console.log('UPLOAD')
            // console.log(this.files);
            this.dialog = false;
            this.$emit('updateFileList', false);
            // await toBase64(this.file);
        },
        convertDate(date=null) {
            let convert1;

            if(date) {
                convert1 = new Date(date);
            }else {
                convert1 = new Date();
            }
            
            const convert2 = convert1.toLocaleDateString();
            let [month, day, year] = convert2.split("/");
            if(day.length == 1) {
                day = '0'+day;
            }
            const finalDate = day+'/'+month+'/'+year;
            return finalDate;
        },
    }
}
</script>

<style scoped>
    .uploadBtn {
        margin: 0;
        margin-bottom: -12px;
        background: linear-gradient(#ffffff, #f2f2f2);
        border: thin solid #6d7d80;
        padding: 0px 9px !important;
        height: 35px !important;
    }

    i {
  font-size: 18px;
}
.inputFile {
  display: inline-block;
}
.inputFile input[type="file"] {
  display: none;
}
.inputFile .custom-file-upload {
  border-radius: 11px;
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
small.typeArquivo {
  color: grey;
  font-weight: 700;
  margin-left: 5px;
}
.teal_bold {
  color: teal;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/uploadFile/UploadFile.vue